// 弃用，某种原因不能在web上登录，只能在app上
import React from 'react'
import { withRouter } from 'react-router-dom'
import { Button, Form, Input } from 'antd-mobile'
import { Wrapper, Container, Nav } from './components/layout'
import { errHandler, request } from '../requests/request'
import requests from '../requests'
import feedback from './components/feedback'

@withRouter
class DevLogin extends React.PureComponent {
  state = {
    // phone: '15600000001',
    phone: '12200000000',
    captcha: '56081095',
  }

  componentDidMount () {
    if (sessionStorage.getItem('token')) {

    }
  }

  render () {
    const { phone, captcha } = this.state
    return <Container>
      <Nav>DevLogin</Nav>
      <Wrapper>
        <Form layout={'horizontal'}>
          <Form.Item label={'phone'}>
            <Input value={phone} onChange={v => this.setState({ phone: v })}></Input>
          </Form.Item>
          <Form.Item label={'captcha'}>
            <Input value={captcha} onChange={v => this.setState({ captcha: v })}></Input>
          </Form.Item>
        </Form>
        <div className={'p-4 text-right'}>
          <Button onClick={() => {
            feedback.toast.loading()
          }}>test</Button>
          <Button onClick={this.login}>LOGIN</Button>
        </div>
      </Wrapper>
    </Container>
  }

  login = () => {
    const { phone, captcha } = this.state
    feedback.toast.loading()
    requests.account.login({ username: phone, captcha })
      .then(res => {
        feedback.toast.success()
        // old
        window.axios.setToken(res['token'])

        //
        request.setToken(res['token'])
      })
      .catch(errHandler)

    // const config = {
    //   method: 'post',
    //   url: window.API.User.postLoginRequest,
    //   data: {
    //     username: phone,
    //     captcha
    //   }
    // }
    // window.toast.loading('请求中...')
    // window.axios(config).then(handleResponse())
    //   .then(res => {
    //     window.axios.setToken(res['token'])
    //     request.setToken(res['token'])
    //     // window.postMessage(JSON.stringify({ type: 'login', data: res['token'] }), '*')
    //     // postMessage({ type: window.POST_TYPE.LOGIN, data: res['token'] })
    //     window.toast.success('登陆成功', 2, () => {
    //
    //     })
    //   })
    //   .catch(error => {
    //     console.error(error)
    //     window.toast.fail(error.message)
    //   })
  }

}

export default DevLogin
